import { HelpOverlayTypes, HelpForm } from './types';
import { HelpOverlayActions } from './actions';

export function helpOverlayReducer(
  state: HelpForm = { emailSubject: '', emailText: '' },
  action: HelpOverlayActions,
) {
  switch (action.type) {
    case HelpOverlayTypes.SetValues:
      return action.form;
    default:
      return state;
  }
}
